const Balance = () => import('./Balance.vue')

const List = () => import('./pages/List.vue')
const Create = () => import('./pages/Create.vue')
const Edit = () => import('./pages/Edit.vue')

const routes = {
  component: Balance,
  path: '/extrato',
  meta: {
    label: 'Extrato Financeiro'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'balanceList',
      meta: {
        label: 'Visualizar Extrato',
        requiredPermission: {resource: 'balance', value: 'view'}
      }
    },
    {
      path: 'cadastro',
      component: Create,
      name: 'balanceCreate',
      meta: {
        hidden: true,
        label: 'Cadastrar',
        requiredPermission: {resource: 'balance', value: 'manage'}
      }
    },
    {
      path: 'atualizar/:id',
      component: Edit,
      name: 'balanceEdit',
      meta: {
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'balance', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/balance/routes.js